// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./vuex/store";
import http from "./plugins/http";
import VueProgressBar from "vue-progressbar";
import interceptor from "./interceptor";
import vuelidate from "vuelidate";
import filters from "./filters/index";
import directives from "./directives/index";
import eventbus from "./plugins/eventbus";
import modal from "./plugins/modal";
import iziToast from "./plugins/iziToast";
import messages from "./plugins/messages";
import ToggleButton from "vue-js-toggle-button";
import ElementUI from "element-ui";
import mouseMenu from "vue-mouse-menu";
import lang from "element-ui/lib/locale/lang/pt-br";
import locale from "element-ui/lib/locale";
import "bootstrap/dist/css/bootstrap.css";
import "admin-lte/dist/css/AdminLTE.css";
import "admin-lte/dist/css/skins/skin-blue.css";
import "font-awesome/css/font-awesome.css";
import "izitoast/dist/css/iziToast.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "animate.css/animate.css";
import "./assets/style/scroll-bar.css";
import "font-awesome-animation/dist/font-awesome-animation.min.css";
import "element-ui/lib/theme-chalk/index.css";
import "./includes.js";
// require("./includes");

locale.use(lang);

Vue.config.productionTip = false;

Vue.use(http, { interceptor });
Vue.use(VueProgressBar, {
  color: "#FFF",
  thickness: "6px",
});
Vue.use(vuelidate);
Vue.use(eventbus);
Vue.use(modal);
Vue.use(iziToast);
Vue.use(messages);
Vue.use(ToggleButton);
Vue.use(ElementUI);
Vue.use(mouseMenu);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  filters,
  directives,
  template: "<App/>",
  components: { App },
});
